import { stepModel } from '../step/step-model';

/**
 * Remove all preceding and succeeding spaces
 * and ensure all inner spaces are made of a single space
 */
var trimWhitespaces = function trimWhitespaces(string) {
  if (!string) {
    return string;
  }
  return string.trim().replace(/\s+/gi, ' ');
};

// this actually returns "how many whitespace-blocks are internal to string"
//  which for its uses in the project suffices for a word-count
var getWordCount = function getWordCount(string) {
  return string ? trimWhitespaces(string).split(' ').length : 0;
};

// how many non-whitespace characters in string?
var getLetterCount = function getLetterCount(string) {
  if (!string) {
    return 0;
  }
  var letterMatch = string.match(/\S/g);
  if (!letterMatch) {
    return 0;
  }
  return letterMatch.length;
};

var isHangman = function isHangman(step) {
  return step.type === 'writing' && step.behavior && step.behavior.inputType === 'hangman';
};

var isReady = function isReady(step, values) {
  if (isHangman(step)) {
    // what we want to compare is how many non-whitespace characters the user has
    //  entered - the values[0] string uses spaces as placeholders, so we need to ignore them
    var userAnswerNonwhiteChars = getLetterCount(values[0]);
    if (userAnswerNonwhiteChars === 0) {
      return false;
    }
    var actualAnswerNonwhiteChars = getLetterCount(step.content[1][0].text);
    return userAnswerNonwhiteChars === actualAnswerNonwhiteChars;
  }
  return stepModel.isReady(step, values);
};

/**
 * Returns array of possible answers for each answer.
 * @param step
 * @returns [[]]
 */
var getCorrectAnswers = function getCorrectAnswers(step) {
  var correctAnswers = step.correct;
  var allPossibleAnswers = step.content[1];
  var possibleAnswers = correctAnswers.map(function (correctAnswer) {
    return correctAnswer.split(':');
  });
  return possibleAnswers.map(function (answerIds) {
    return answerIds.map(function (answerId) {
      return allPossibleAnswers.find(function (answer) {
        return answer.id === answerId;
      });
    });
  });
};

// this should find any combo of punct chars and whitespace on either
//  end of the string.  We only want to remove punct chars from the
//  ends and if there is whitespace before or between them we will need
//  to get rid of that too.
var endPunctOrWSpaceRegexp = /^[.?!¿¡\s\xA0]+|[.?!¿¡\s\xA0]+$/g;
var cleanAnswer = function cleanAnswer(answerText, stripPunct) {
  var cleanedAnswer = answerText;
  if (stripPunct) {
    cleanedAnswer = cleanedAnswer.replace(endPunctOrWSpaceRegexp, '');
  }
  cleanedAnswer = cleanedAnswer.replace(/[“”]/g, '"');
  cleanedAnswer = cleanedAnswer.replace(/[‘’]/g, "'");
  cleanedAnswer = trimWhitespaces(cleanedAnswer).toLowerCase();
  return cleanedAnswer;
};

var getAnswers = function getAnswers(step, values) {
  var correctAnswers = getCorrectAnswers(step);
  return values.map(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var i = arguments[1];

    var correctAnswer = correctAnswers[i].find(function (answer) {
      var cleanCorrectText = cleanAnswer(answer.text, step.behavior.ignorePunctuation);
      var cleanUserText = cleanAnswer(value, step.behavior.ignorePunctuation);
      return cleanCorrectText === cleanUserText;
    });
    return {
      correct: !!correctAnswer,
      answer: correctAnswer ? correctAnswer.id : value
    };
  });
};

var hasExample = function hasExample() {
  var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return !!(step.behavior && step.behavior.firstIsExample);
};

/**
 * Given an array of answer ids return an array of corresponding text answers
 **/
var getCorrectByIndex = function getCorrectByIndex(step, index) {
  var correctId = step.correct[index].split(':')[0];
  return step.content[1].find(function (answer) {
    return answer.id === correctId;
  });
};

function generateDefaultValues(step) {
  var defaultValues = step.content[0].map(function () {
    return '';
  });
  if (hasExample(step)) {
    defaultValues[0] = getCorrectByIndex(step, 0).text;
  }
  return defaultValues;
}

export var stepWritingModel = {
  getWordCount: getWordCount,
  getLetterCount: getLetterCount,
  isHangman: isHangman,
  isReady: isReady,
  getCorrectAnswers: getCorrectAnswers,
  getAnswers: getAnswers,
  hasExample: hasExample,
  getCorrectByIndex: getCorrectByIndex,
  generateDefaultValues: generateDefaultValues
};